import { Component, OnInit } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { Router } from '@angular/router';
import { Utils } from '../common/services/utils.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  constructor(private router: Router,
    private utils: Utils,
    private httpService: HttpRequestService,
    private confirmationService: ConfirmationService) { }

  dashboardItems: any;
  showFlashMsg = true;
  showInfoMsg = false;

    privacyConfigForm: FormGroup = new FormGroup({
      strPdoPrivacy: new FormControl(true, Validators.required),
      strDataPrivacy: new FormControl(true, Validators.required)
    });

  // onClickPax() {
  //  this.router.navigate(['/app/transaction/pax-quick-response']);
  // }

  onSubmit() {

    let formValues = this.privacyConfigForm.value

    //this.privacyConfigForm.get(formValues.strDataPrivacy).setValue(true);

     if ((formValues.strPdoPrivacy == false ) || (formValues.strDataPrivacy == false)) {
       this.confirmationService.confirm({
        message: 'Kindly select both the check box',
        header: 'Alert !',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        rejectVisible: false,
      });
    }
    else {
    const requestData = this.utils.constructRequestData(formValues, 'CoreJourneyPlanService', 'dataPrivacyCheck');

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
      (response: any) => {
        if (response && response.strFailureMsg == null) {
        this.showFlashMsg = false;
           }
      });
}
  }


  downloadLocationDir() {
    const url = 'assets/templates/Location_Directory_Rev_1.0-01052020.xlsx';
    const downloadName = 'Location_Directory_Rev_1.0-01052020.xlsx';
    this.utils.downloadSystemFile(url, downloadName);
  }

  ngOnInit() {
    this.showInfoMsg = true;
    // this.dashboardComponents.businesProcess: any[] = [];
    // this.dashboardItems = this.dashboardService.dashboardMenuItems ? this.dashboardService.dashboardMenuItems : null;
    // this.dashboardService.dashboardItems.subscribe(
    //   (dbItems) => {
    //     if (dbItems) {
    //       this.dashboardItems = dbItems;
    //     }
    //   }
    // );
  }
}
